/**
 * Captcha bypass flag for local dev and bot-driven testing.
 *
 * Default off. Set NEXT_PUBLIC_CAPTCHA_BYPASS=1 only in .env.development so
 * the bypass is inlined into client bundles only for development, and read
 * from process.env at runtime on the server. Never set this in preview or
 * production .env files.
 */
export const captchaBypassEnabled = process.env.NEXT_PUBLIC_CAPTCHA_BYPASS === '1'
